import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { ContentCard } from "../../../shared/components/contentCard/contentCard";
import { emptyStateStyles } from "../empty-state/empty-state.styles";
import { EmptyState } from "../empty-state";
import { Checked } from "../../../shared/icons";

export const ListContent = ({
  request,
  contentList,
  isAssignedContent,
  bookmarkContent,
  isFilterChanged,
}) => {
  const { isPending, isDone } = request;
  const styles = emptyStateStyles();

  const getSuggestionMessages = () =>
    !isFilterChanged
      ? [
          <div className={styles.suggestionContainer}>
            <Checked isEnabled={false} className="" />
            <Typography className={styles.suggestion}>
              Check out the ‘All Content’ tab in this page to bookmark some
              favorite content.
            </Typography>
          </div>,
          <div className={styles.suggestionContainer}>
            <Checked isEnabled={false} className="" />
            <Typography className={styles.suggestion}>
              In case you haven’t taken the Assessment,{" "}
              <span className={styles.red}>take it now </span> to get some
              content recommendations.
            </Typography>
          </div>,
        ]
      : [
          <div className={styles.suggestionContainer}>
            <Checked isEnabled={false} className="" />
            <Typography className={styles.suggestion}>
              Make sure that all words are spelled correctly.
            </Typography>
          </div>,
          <div className={styles.suggestionContainer}>
            <Checked isEnabled={false} className="" />
            <Typography className={styles.suggestion}>
              Try different keywords.
            </Typography>
          </div>,
        ];

  return (
    <>
      {!isPending && isDone && !contentList.length && (
        <EmptyState
          title={
            !isFilterChanged ? "No content found" : "Oops! No results found."
          }
          suggestions={getSuggestionMessages()}
        />
      )}
      {contentList.map(
        ({
          contentId,
          title,
          resourceType,
          imagePath,
          duration,
          category,
          createdAt,
          assignedAt,
          bookmark,
        }) => (
          <Grid item key={contentId}>
            <ContentCard
              isAssignedContent={isAssignedContent}
              contentId={contentId}
              title={title}
              resourceType={resourceType}
              imageUrl={imagePath}
              minutes={duration}
              category={category}
              createdAt={createdAt || assignedAt}
              isBookmarked={bookmark}
              bookmarkContent={bookmarkContent}
            />
          </Grid>
        )
      )}
    </>
  );
};

ListContent.propTypes = {
  contentList: PropTypes.arrayOf(
    PropTypes.shape({
      contentId: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      contentType: PropTypes.string.isRequired,
      imagePath: PropTypes.string,
      duration: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired,
      createdAt: PropTypes.string,
      assignedAt: PropTypes.string,
    })
  ).isRequired,
  isAssignedContent: PropTypes.bool,
  request: PropTypes.shape({
    isPending: PropTypes.bool.isRequired,
    isDone: PropTypes.bool.isRequired,
  }).isRequired,
  bookmarkContent: PropTypes.func.isRequired,
  isFilterChanged: PropTypes.bool.isRequired,
};

ListContent.defaultProps = {
  isAssignedContent: false,
};
